import type { LoadChoice, LoadOccupants } from './simulationLoadChoice';

/** E2E-FIX1 (GAP-12) : état public de la fenêtre « Commandes du Studio », lu par le Copilote.
 * - `open` : la fenêtre est affichée ; le tiroir du Copilote se met alors en retrait (inerte, sous la fenêtre) ;
 * - `steps` : nombre d'étapes du plan ou de commandes proposées ;
 * - `choice` (GAP-10) : le même choix que la fenêtre quand « Charger la simulation » trouve des tables déjà remplies. */
export type StudioPlanChoice = {
  occupants: LoadOccupants;
  /** Nom affichable de chaque simulation occupante (liste du dossier) ; absent si la simulation n'est plus listée. */
  names: Record<string, string>;
  available: Record<LoadChoice, boolean>;
  choose: (choice: LoadChoice) => void;
};
export type StudioPlanWindow = { open: boolean; steps: number; choice: StudioPlanChoice | null };
const CLOSED: StudioPlanWindow = { open: false, steps: 0, choice: null };
let current: StudioPlanWindow = CLOSED;
const listeners = new Set<() => void>();
export const getStudioPlanWindow = (): StudioPlanWindow => current;
export const subscribeStudioPlanWindow = (listener: () => void): (() => void) => { listeners.add(listener); return () => { listeners.delete(listener); }; };
export function setStudioPlanWindow(next: StudioPlanWindow | null): void {
  const value = next ?? CLOSED;
  if (value.open === current.open && value.steps === current.steps && value.choice === current.choice) return;
  current = value;
  listeners.forEach(listener => listener());
}
